import React, { useState } from 'react';
import styles from './Pagination.module.css';

const PaginationExample = () => {
  // Sample data array with image URLs
  const data = [
    { id: 1, image: "https://resizing.flixster.com/DLjG9XyXGH3NORlYWUeiIXqiO0s=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p195763_p_v7_aa.jpg" },
    { id: 2, image: "https://resizing.flixster.com/6bpItnDsw-F8f6BExRUmT-W0D2A=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p193299_p_v13_ai.jpg" },
    { id: 3, image: "https://resizing.flixster.com/DLjG9XyXGH3NORlYWUeiIXqiO0s=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p195763_p_v7_aa.jpg" },
    { id: 4, image: "https://resizing.flixster.com/6bpItnDsw-F8f6BExRUmT-W0D2A=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p193299_p_v13_ai.jpg" },
    { id: 5, image: "https://resizing.flixster.com/DLjG9XyXGH3NORlYWUeiIXqiO0s=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p195763_p_v7_aa.jpg" },
    { id: 6, image: "https://resizing.flixster.com/6bpItnDsw-F8f6BExRUmT-W0D2A=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p193299_p_v13_ai.jpg" },
    { id: 7, image: "https://resizing.flixster.com/DLjG9XyXGH3NORlYWUeiIXqiO0s=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p195763_p_v7_aa.jpg" },
    { id: 8, image: "https://resizing.flixster.com/1m7veD0S0MaFp_uqedOmzTDueeA=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p8609471_p_v8_az.jpg" },
    { id: 9, image: "https://resizing.flixster.com/DLjG9XyXGH3NORlYWUeiIXqiO0s=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p195763_p_v7_aa.jpg" },
    { id: 10, image: "https://resizing.flixster.com/1m7veD0S0MaFp_uqedOmzTDueeA=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p8609471_p_v8_az.jpg" },
    { id: 11, image: "https://resizing.flixster.com/DLjG9XyXGH3NORlYWUeiIXqiO0s=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p195763_p_v7_aa.jpg" },
    { id: 12, image: "https://resizing.flixster.com/1m7veD0S0MaFp_uqedOmzTDueeA=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p8609471_p_v8_az.jpg" },
    { id: 13, image: "https://resizing.flixster.com/DLjG9XyXGH3NORlYWUeiIXqiO0s=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p195763_p_v7_aa.jpg" },
    { id: 14, image: "https://resizing.flixster.com/6bpItnDsw-F8f6BExRUmT-W0D2A=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p193299_p_v13_ai.jpg" },
    { id: 15, image: "https://resizing.flixster.com/1m7veD0S0MaFp_uqedOmzTDueeA=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p8609471_p_v8_az.jpg" },
    { id: 6, image: "https://resizing.flixster.com/6bpItnDsw-F8f6BExRUmT-W0D2A=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p193299_p_v13_ai.jpg" },
    { id: 7, image: "https://resizing.flixster.com/DLjG9XyXGH3NORlYWUeiIXqiO0s=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p195763_p_v7_aa.jpg" },
    { id: 8, image: "https://resizing.flixster.com/1m7veD0S0MaFp_uqedOmzTDueeA=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p8609471_p_v8_az.jpg" },
    { id: 9, image: "https://resizing.flixster.com/DLjG9XyXGH3NORlYWUeiIXqiO0s=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p195763_p_v7_aa.jpg" },
    { id: 10, image: "https://resizing.flixster.com/1m7veD0S0MaFp_uqedOmzTDueeA=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p8609471_p_v8_az.jpg" },
    { id: 11, image: "https://resizing.flixster.com/DLjG9XyXGH3NORlYWUeiIXqiO0s=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p195763_p_v7_aa.jpg" },
    { id: 12, image: "https://resizing.flixster.com/1m7veD0S0MaFp_uqedOmzTDueeA=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p8609471_p_v8_az.jpg" },
    { id: 13, image: "https://resizing.flixster.com/DLjG9XyXGH3NORlYWUeiIXqiO0s=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p195763_p_v7_aa.jpg" },
    { id: 14, image: "https://resizing.flixster.com/6bpItnDsw-F8f6BExRUmT-W0D2A=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p193299_p_v13_ai.jpg" },
    { id: 15, image: "https://resizing.flixster.com/1m7veD0S0MaFp_uqedOmzTDueeA=/206x305/v2/https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p8609471_p_v8_az.jpg" },
  ];

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Calculate pagination values
  const lastIndex = currentPage * itemsPerPage;
  const firstIndex = lastIndex - itemsPerPage;
  const currentItems = data.slice(firstIndex, lastIndex);
  const totalPages = Math.ceil(data.length / itemsPerPage);

  // Generate page numbers
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className={styles.container}>
      {/* Items display in grid format */}
      <div className={`${styles.gridContainer} ${window.innerWidth <= 768 ? styles.gridContainerMobile : ""}`}>
        {currentItems.map(item => (
          <div 
            key={item.id} 
            className={styles.card}
          >
            <img 
              src={item.image} 
              alt={`Item ${item.id}`} 
              className={styles.image}
            />
          </div>
        ))}
      </div>

      {/* Pagination controls */}
      <div className={styles.paginationWrapper}>
        <button
          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className={`${styles.paginationButton} ${currentPage === 1 && styles.paginationButtonDisabled}`}
        >
          Previous
        </button>

        <div className="flex gap-1">
          {pageNumbers.map(number => (
            <button
              key={number}
              onClick={() => setCurrentPage(number)}
              className={`${styles.pageNumberButton} ${currentPage === number ? styles.pageNumberButtonActive : ""}`}
            >
              {number}
            </button>
          ))}
        </div>

        <button
          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
          className={`${styles.paginationButton} ${currentPage === totalPages && styles.paginationButtonDisabled}`}
        >
          Next
        </button>
      </div>

      {/* Page information */}
      <div className={styles.pageInfo}>
        Page {currentPage} of {totalPages}
      </div>
    </div>
  );
};

export default PaginationExample;
